import GlobalMessagePopup from './GlobalMessagePopup';

export default GlobalMessagePopup;
